import { useState } from "react";
import { Tab, Nav, Row, Col, Accordion } from "react-bootstrap";
import { merchantFaqData } from "./data/merchants";

export const MerchantFAQs = () => {
  const [activeTab, setActiveTab] = useState<string>(
    merchantFaqData[0].tabHeader
  );

  return (
    <div className="container my-4">
      <Tab.Container
        activeKey={activeTab}
        onSelect={(k) => k && setActiveTab(k)}
      >
        <Row>
          <Col sm={12}>
            <Nav variant="pills" className="flex-row">
              {merchantFaqData.map((item) => (
                <Nav.Item key={item.tabHeader}>
                  <Nav.Link eventKey={item.tabHeader}>
                    {item.tabHeader}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>

          <Col sm={12}>
            <Tab.Content>
              {merchantFaqData.map((item) => (
                <Tab.Pane eventKey={item.tabHeader} key={item.tabHeader}>
                  <div className="py-4">
                    <Accordion defaultActiveKey="0">
                      {item.tabContent.map((content, idx) => {
                        // Handle simple string content
                        if (typeof content === "string") {
                          return (
                            <Accordion.Item
                              eventKey={String(idx)}
                              key={idx}
                              className="mb-2 border rounded "
                            >
                              <Accordion.Header>
                                {item.tabHeader}
                              </Accordion.Header>
                              <Accordion.Body>
                                <p>{content}</p>
                              </Accordion.Body>
                            </Accordion.Item>
                          );
                        }

                        // Handle nested content with section and points (Buyers tab)
                        if ("section" in content && "points" in content) {
                          return content?.points?.map((pt, i) => (
                            <Accordion.Item
                              eventKey={`${idx}-${i}`}
                              key={`${idx}-${i}`}
                              className="mb-2 border rounded "
                            >
                              <Accordion.Header>{pt.point}</Accordion.Header>
                              <Accordion.Body>
                                {Array.isArray(pt.detail) ? (
                                  <ul>
                                    {pt.detail.map((d, index) => (
                                      <li key={index}>{d}</li>
                                    ))}
                                  </ul>
                                ) : (
                                  <p>{pt.detail}</p>
                                )}
                                {/* {"subpoints" in pt && pt.subpoints && (
                                  <ul>
                                    {pt.subpoints.map((sp, spi) => (
                                      <li key={spi}>{sp}</li>
                                    ))}
                                  </ul>
                                )} */}
                              </Accordion.Body>
                            </Accordion.Item>
                          ));
                        }

                        // Handle standard point/detail items
                        return (
                          <Accordion.Item
                            eventKey={String(idx)}
                            key={idx}
                            className="mb-2 border rounded "
                          >
                            <Accordion.Header>
                              {content?.point}
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>{content.detail}</p>
                            </Accordion.Body>
                          </Accordion.Item>
                        );
                      })}
                    </Accordion>
                  </div>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};
